import React from 'react';
import { Redirect } from 'react-router-dom';
import Helper from '../Utils/Helpers';
import { routes } from '../Routing/routes';

export class Logout extends React.Component<any, any> {
	render() {
		Helper.removeToken();

		return <Redirect to={routes.login} />;
	}
}
